'use client';

import { useEffect, useState } from 'react';

import { useAtomValue } from 'jotai';

import { classNames } from '@/utils';
import { getMenuLocalStorage } from '@/utils/localStorage/menuLocalStorage';

import { HeaderPlatform } from '@/components/layouts/LayoutPlatform';
import { MenuDesktop } from '@/components/layouts/LayoutPlatform/components/Menu/MenuDesktop';
import { menuOverlayAtom } from '@/components/layouts/LayoutPlatform/components/Menu/menuOverlayAtom';
import { PromotedPostsUpsellBanner } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/PromotedPostsUpsellBanner';
import { ReminderSubscriptionEndBanner } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/ReminderSubscriptionEndBanner';

export type WrapperPlatformProps = {
    noPadding?: boolean;
    disableMainScroll?: boolean;
    className?: string;
    children: React.ReactNode;
};

export function WrapperPlatformContent({
    noPadding = false,
    disableMainScroll = false,
    className,
    children
}: WrapperPlatformProps) {
    // Initialize with safe default, then read from localStorage on client
    const [stickyMenu, setStickyMenu] = useState(true);
    const menuOverlay = useAtomValue(menuOverlayAtom);

    // Read localStorage value only on client side
    useEffect(() => {
        setStickyMenu(getMenuLocalStorage());
    }, []);

    return (
        <>
            <MenuDesktop stickyMenu={stickyMenu} setStickyMenu={setStickyMenu} />
            <div
                className={classNames('flex max-w-full flex-1 flex-col px-3 sm:pl-0', {
                    'sm:w-[calc(100%-72px)]': !stickyMenu,
                    'sm:w-[calc(100%-208px)]': stickyMenu
                })}>
                <HeaderPlatform />
                <div
                    id="wrapper-logged"
                    className={classNames(
                        'main-content-scroll relative z-0 flex flex-1 flex-col rounded-t-2xl bg-white/40 @container/wrapper-platform-content dark:bg-icoDarkMode-deepBlack/40',
                        { scrollbar: !disableMainScroll, 'overflow-hidden': disableMainScroll }
                    )}>
                    <ReminderSubscriptionEndBanner />
                    <PromotedPostsUpsellBanner />
                    <div
                        className={classNames(className, 'flex flex-1 flex-col', {
                            'px-5 py-5 sm:px-8 sm:py-8': !noPadding,
                            scrollbar: disableMainScroll
                        })}>
                        {children}
                    </div>
                </div>
            </div>
            {menuOverlay}
        </>
    );
}
